import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { MyEInvoicePortalSearchRequestResponseModel } from '../../../../../models/aggregates/e-invoice/my-einvoice-portal-search-request-response.model';


@Injectable({
  providedIn: 'root'
})

export class MyEInvoicePortalRequestSearchService extends BaseApiPublicLoginTemplateService<MyEInvoicePortalSearchRequestResponseModel, MyEInvoicePortalSearchRequestResponseModel, MyEInvoicePortalSearchRequestResponseModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/einvoice-portal-request/search'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/einvoice-portal-request/search/' + BaseApiTemplateService.BACKOFFICE_EP
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/einvoice-portal-request/search/' + BaseApiTemplateService.BACKOFFICE_EP
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/einvoice-portal-request/search/' + BaseApiTemplateService.PUBLIC_EP
    this.httpClient = http;
  }
}
